"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _75F3RDBEcjs = require('../__chunks/75F3RDBE.cjs');


var _UGAVMSQJcjs = require('../__chunks/UGAVMSQJ.cjs');


var _GDZQUFNPcjs = require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/CVLMIMPT.cjs');
require('../__chunks/2RUCRSRF.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');








var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');


var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/select/select-store.ts
function createSelectStore({
  combobox,
  ...props
} = {}) {
  const store = _WMTGHDLEcjs.mergeStore.call(void 0, 
    props.store,
    _WMTGHDLEcjs.omit.call(void 0, combobox, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  _WMTGHDLEcjs.throwOnConflictingProps.call(void 0, props, store);
  const syncState = store.getState();
  const composite = _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    store,
    virtualFocus: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.virtualFocus,
      syncState.virtualFocus,
      true
    ),
    includesBaseElement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.includesBaseElement,
      syncState.includesBaseElement,
      false
    ),
    activeId: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.activeId,
      syncState.activeId,
      props.defaultActiveId,
      null
    ),
    orientation: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.orientation,
      syncState.orientation,
      "vertical"
    )
  });
  const popover = _75F3RDBEcjs.createPopoverStore.call(void 0, {
    ...props,
    store,
    placement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.placement,
      syncState.placement,
      "bottom-start"
    )
  });
  const initialValue = new String("");
  const initialState = {
    ...composite.getState(),
    ...popover.getState(),
    value: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.value,
      syncState.value,
      props.defaultValue,
      initialValue
    ),
    setValueOnMove: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.setValueOnMove,
      syncState.setValueOnMove,
      false
    ),
    labelElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState.labelElement, null),
    selectElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState.selectElement, null),
    listElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState.listElement, null)
  };
  const select = _WMTGHDLEcjs.createStore.call(void 0, initialState, composite, popover, store);
  _WMTGHDLEcjs.setup.call(void 0, 
    select,
    () => _WMTGHDLEcjs.sync.call(void 0, select, ["value", "items"], (state) => {
      if (state.value !== initialValue) return;
      if (!state.items.length) return;
      const item = state.items.find(
        (item2) => !item2.disabled && item2.value != null
      );
      if ((item == null ? void 0 : item.value) == null) return;
      select.setState("value", item.value);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    select,
    () => _WMTGHDLEcjs.sync.call(void 0, select, ["mounted"], (state) => {
      if (state.mounted) return;
      select.setState("activeId", initialState.activeId);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    select,
    () => _WMTGHDLEcjs.sync.call(void 0, select, ["mounted", "items", "value"], (state) => {
      if (combobox) return;
      if (state.mounted) return;
      const values = _GDZQUFNPcjs.toArray.call(void 0, state.value);
      const lastValue = values[values.length - 1];
      if (lastValue == null) return;
      const item = state.items.find(
        (item2) => !item2.disabled && item2.value === lastValue
      );
      if (!item) return;
      select.setState("activeId", item.id);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    select,
    () => _WMTGHDLEcjs.batch.call(void 0, select, ["setValueOnMove", "moves"], (state) => {
      const { mounted, value, activeId } = select.getState();
      if (!state.setValueOnMove && mounted) return;
      if (Array.isArray(value)) return;
      if (!state.moves) return;
      if (!activeId) return;
      const item = composite.item(activeId);
      if (!item || item.disabled || item.value == null) return;
      select.setState("value", item.value);
    })
  );
  return {
    ...composite,
    ...popover,
    ...select,
    combobox,
    setValue: (value) => select.setState("value", value),
    setLabelElement: (element) => select.setState("labelElement", element),
    setSelectElement: (element) => select.setState("selectElement", element),
    setListElement: (element) => select.setState("listElement", element)
  };
}


exports.createSelectStore = createSelectStore;
